// extracted by mini-css-extract-plugin
module.exports = {"title":"MediaContent_title__NlSVh","is_bigger":"MediaContent_is_bigger__RZ7eI","is_biggerLineHeight":"MediaContent_is_biggerLineHeight__Z_aVi","text":"MediaContent_text__Ic0sc"};